import React from 'react';

const Logo = ({ size = 'default', showText = true, className = '' }) => {
    const sizeClasses = {
        small: 'w-6 h-6',
        default: 'w-8 h-8',
        large: 'w-12 h-12'
    };

    const textSizes = {
        small: 'text-sm',
        default: 'text-lg',
        large: 'text-base'
    };

    return (
        <div className={`flex items-center space-x-2 ${className}`}>
            <div className={`${sizeClasses[size]} bg-primary-600 rounded-lg flex items-center justify-center`}>
                <span className="text-white font-bold text-sm">B</span>
            </div>
            {showText && (
                <span className={`font-bold text-content-primary ${textSizes[size]}`}>
                    BlockNotify
                </span>
            )}
        </div>
    );
};

export default Logo;
